import React from 'react'
import img1 from '../../Assete/gellery Image/productImage/1 grey.jpg'
import img2 from '../../Assete/gellery Image/productImage/25.jpg'
import img3 from '../../Assete/gellery Image/productImage/2Y8A5227 copy.jpg'
import img4 from '../../Assete/gellery Image/productImage/2Y8A5381 copy.jpg'
import img5 from '../../Assete/gellery Image/productImage/2Y8A5583 copy.jpg'
import img6 from '../../Assete/gellery Image/productImage/39.jpg'
import img7 from '../../Assete/gellery Image/productImage/13.jpg'
import img8 from '../../Assete/gellery Image/productImage/2Y8A9606.jpg'
import img9 from '../../Assete/gellery Image/productImage/3.jpg'
import img10 from '../../Assete/gellery Image/productImage/Double Side Clock-4.jpg'
import img11 from '../../Assete/gellery Image/productImage/Revive 2.jpg'
import img12 from '../../Assete/gellery Image/productImage/04.jpg'
import { gelleryData } from './dummay';
import { useNavigate } from 'react-router-dom'
function Banner() {
    const navigate=useNavigate()
    return (
        <div className='responsive-container'>
            <div className='text-for-heading mt-3'>
                <h1>Experience the Vision: Nask Studio's Creative Photography Portfolio.</h1>
                <p>At Nask Studio, we believe every moment tells a story, and every detail matters. Our photographers are more <br />than just picture-takers; they're visionaries with a keen eye for capturing the essence of your world. </p>
            </div>
            <div className='row'>
                <div className='col-lg-2 m-0 p-0 px-1'>
                    <div>
                        <img src={img3} style={{ height: "350px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                        <img src={img2} style={{ height: "200px" }} className='w-100 mb-2' alt='...' />
                    </div>
                </div>
                <div className='col-lg-2 mx-0 p-0 px-1' style={{ marginTop: "78px" }}>
                    <img src={img9} style={{ height: "240px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                    <img src={img10} style={{ height: "230px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                </div>
                <div className='col-lg-2 mx-0 p-0 px-1' style={{ marginTop: "180px" }}>
                    <img src={img1} style={{ height: "210px" }} className='w-100 mb-2' alt='...' />
                    <img src={img4} style={{ height: "160px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                </div>

                <div className='col-lg-2 mx-0 p-0 px-1' style={{ marginTop: "140px" }}>
                    <img src={img5} style={{ height: "220px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                    <img src={img6} style={{ height: "190px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                </div>
                <div className='col-lg-2 mx-0 p-0 px-1' style={{ marginTop: "68px" }}>
                    <img src={img7} style={{ height: "280px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                    <img src={img8} style={{ height: "200px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                </div>
                <div className='col-lg-2 m-0 p-0 px-1'>
                    <img src={img11} style={{ height: "350px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                    <img src={img12} style={{ height: "200px", objectFit: "cover" }} className='w-100 mb-2' alt='...' />
                </div>
            </div>
            <div className='list_section mt-5'>

                <ul className='p-0'>
                    {gelleryData?.map((item, idx) => {
                        return (
                            <li onClick={()=>navigate(`/service-detail/${item?.slug}`)}>
                                <h3><span className='mx-2'>0{idx+1}</span>{item?.name}</h3>
                                <img src={item?.img} alt='...' />
                            </li>
                        )
                    })}

                </ul>
            </div>
          
        </div>
    )
}

export default Banner